import Reveal from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "كيف أستعمل بخاخ يوكيور؟",
    a: "نظّف الظفر وجففه جيداً، ثم رشّ كمية كافية على الظفر وحوله مرة إلى مرتين يومياً واتركه يجف. المواظبة اليومية هي سرّ النتيجة.",
  },
  {
    q: "هل التوصيل متوفر في مدينتي؟",
    a: "نعم، نوصّل لجميع المدن المغربية، والتوصيل مجاني. تدفع 129 درهم فقط عند استلام طلبك.",
  },
  {
    q: "متى تظهر النتائج؟",
    a: "تختلف المدة من شخص لآخر حسب حالة الظفر ومدى المواظبة. الأظافر تنمو ببطء طبيعي، لذلك ننصح بالاستمرار على الطقس اليومي وعدم الانقطاع.",
  },
  {
    q: "هل المنتج طبيعي فعلاً؟",
    a: "نعم، تركيبة طبيعية 100% بخلاصة اللافندر والأوكالبتوس وشجرة الشاي والزعتر، وبدون أي عطر مضاف.",
  },
  {
    q: "هل يغني المنتج عن الطبيب؟",
    a: "لا. يوكيور مستحضر للعناية التجميلية بالأظافر. إذا كانت الحالة متقدمة أو مؤلمة، ننصحك باستشارة طبيب أو صيدلي.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="border-t border-[#2E9E6B]/10 bg-[#E8F5EF]/40 py-20 lg:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Reveal className="text-center">
          <p className="text-sm font-bold tracking-[0.3em] text-[#2E9E6B]">أسئلة شائعة</p>
          <h2 className="font-display mt-3 text-2xl font-black text-[#0F1E19] sm:text-3xl">
            كل ما تحتاج معرفته
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="rounded-2xl border border-[#2E9E6B]/15 bg-white px-5"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-5 text-right text-sm font-bold text-[#0F1E19] hover:text-[#1F7A52] hover:no-underline sm:text-base">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-[#566B63]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
